import React from "react";
import { FontStyle, JobClickType } from "../../constants";
import { JobFontSize, TaggedRow } from "../../utils/jobUtils";
import { Box } from "@mui/material";

const styles = {
  sectionBody: {
    ...FontStyle.body,
    fontSize: JobFontSize.medium,
  },
  blueExpand: {
    ...FontStyle.headingBody,
    fontSize: JobFontSize.medium,
    color: "#0672cb",
    cursor: "pointer",
    // textDecoration: "underline",
    paddingTop: "10px",
    "&:hover": {
      color: "#1033CC",
    },
  },
};

const StandardDescription = ({
  jobDescription,
  url,
  jobId,
  shouldShowMore,
  setShowMore,
  logJobClick,
}) => {
  return (
    <Box sx={styles.sectionBody}>
      {/* show part or all of the description */}
      {shouldShowMore || jobDescription.showIdx === -1
        ? jobDescription.list.map((row, i) => <TaggedRow row={row} key={i} />)
        : jobDescription.list
            .slice(0, jobDescription.showIdx + 1)
            .map((row, i) => {
              return (
                <TaggedRow
                  row={row}
                  key={i}
                  trimIdx={
                    jobDescription.showIdx === i
                      ? jobDescription.lastElementShown
                      : -1
                  }
                  setShowMore={setShowMore}
                />
              );
            })}

      {/* if expanded, show a temp "... + apply" link*/}
      {(shouldShowMore || jobDescription.showIdx === -1) && (
        <Box
          onClick={() => {
            logJobClick({ clickType: JobClickType.viewMore });
            window.open(url, "_blank");
          }}
          sx={{
            marginTop: "-10px",
            ...styles.blueExpand,
          }}>
          {!jobId.startsWith("gig") ? (
            <div style={{ paddingBottom: "5px" }}>...</div>
          ) : (
            <div style={{ paddingBottom: "5px" }} />
          )}
          <div>Apply on company website</div>
        </Box>
      )}
    </Box>
  );
};

export default StandardDescription;
